import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Scroll from './Scroll';

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(_default, _PureComponent);

  var _super = _createSuper2(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this.state = {
      left: props.scrollLeft || 0,
      top: props.scrollTop || 0
    };
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(_default, [{
    key: "getRect",
    value: function getRect() {
      var left = this.props.scrollLeft === undefined ? this.state.left : this.props.scrollLeft;
      var top = this.props.scrollTop === undefined ? this.state.top : this.props.scrollTop;
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(x, y) {
      var left = this.scrollX ? x : 0;
      var top = this.scrollY ? y : 0;
      this.setState({
        left: left,
        top: top
      });

      if (this.props.onScroll) {
        var _this$props;

        for (var _len = arguments.length, others = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          others[_key - 2] = arguments[_key];
        }

        // @ts-ignore
        (_this$props = this.props).onScroll.apply(_this$props, [left, top].concat(others));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getRect = this.getRect(),
          left = _this$getRect.left,
          top = _this$getRect.top;

      return (
        /*#__PURE__*/
        React.createElement(Scroll, Object.assign({}, this.props, {
          left: left,
          top: top,
          scrollX: this.scrollX,
          scrollY: this.scrollY,
          onScroll: this.handleScroll
        }))
      );
    }
  }, {
    key: "scrollX",
    get: function get() {
      var scroll = this.props.scroll;
      return scroll === 'x' || scroll === 'both';
    }
  }, {
    key: "scrollY",
    get: function get() {
      var scroll = this.props.scroll;
      return scroll === 'y' || scroll === 'both';
    }
  }]);

  return _default;
}(PureComponent);

_default.displayName = 'ShineoutScroll';
_default.defaultProps = {
  scroll: 'both'
};
export { _default as default };